import { BrowserOptions } from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';

const tracesSampleRate = process.env.RAILS_ENV === 'production' ? 0.01 : 0;

const sentryInitOption: BrowserOptions = {
  dsn: process.env.SENTRY_CLIENT_DSN,
  integrations: [new BrowserTracing()],
  ignoreErrors: ['FirebaseError'],

  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: tracesSampleRate,
};

export default sentryInitOption;
